:host {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
    width: 24px;
    height: 24px;

    svg {
        width: 100%;
        height: 100%;
    }
}

:host([size="xs"]) {
    width: 12px;
    height: 12px;
}
:host([size="sm"]) {
    width: 16px;
    height: 16px;
}
:host([size="md"]) {
    width: 24px;
    height: 24px;
}
:host([size="lg"]) {
    width: 32px;
    height: 32px;
}
:host([size="xl"]) {
    width: 40px;
    height: 40px;
}
